import React from "react";
import { Footer } from "../atoms/Footer";
import { useParams } from "react-router-dom";
import { motion, cubicBezier } from "framer-motion";

export const Success: React.FC = () => {
  const { vacancy } = useParams<{ vacancy: string }>();
  const decodedVacancy = vacancy
    ? decodeURIComponent(vacancy)
    : "Nombre no disponible";

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.2 },
    },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 24 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.6, ease: cubicBezier(0.16, 1, 0.3, 1) },
    },
  };

  const fade = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { duration: 0.6, ease: cubicBezier(0.16, 1, 0.3, 1) },
    },
  };

  return (
    <div className="h-[100svh] bg-black text-white">
      <motion.main
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="flex flex-col w-full items-center justify-center py-52 text-center px-4 overflow-hidden"
      >
        <motion.div className="mb-6" variants={fade}>
          {/* Título superior con tracking amplio y tamaño fluido */}
          <motion.h2
            variants={fadeUp}
            style={{ letterSpacing: "3.8vw" }}
            className="text-center font-bold uppercase leading-none mb-2 font-montserrat select-none text-[4vw]"
          >
            GRUPO
          </motion.h2>
          {/* Subtítulo grande, sin tracking exagerado */}
          <motion.h3
            variants={fadeUp}
            className="text-left font-bold uppercase leading-none font-montserrat select-none text-[4vw]"
          >
            PEÑA DEFILLÓ
          </motion.h3>
        </motion.div>

        <motion.div className="max-w-3xl mb-8" variants={fade}>
          <motion.p
            variants={fadeUp}
            className="lg:text-[16px] text-sm font-inter mb-6"
          >
            Ha completado el formulario de solicitud de empleo para el puesto{" "}
            <strong>{decodedVacancy}</strong>.
          </motion.p>
          <motion.p variants={fadeUp} className="text-[13px] font-inter mb-6">
            Su solicitud ha sido enviada con éxito al ciberespacio y lo tenemos
            asegurado.
            <br />
            Gracias por tomarse el tiempo y compartir su información con
            nosotros.
          </motion.p>
          <motion.p variants={fadeUp} className="text-[13px] font-inter">
            En breve recibirás un correo electrónico de confirmación.
          </motion.p>
        </motion.div>

        <motion.div
          variants={fade}
          className="w-full max-w-lg mt-6 flex flex-row justify-between items-center gap-8 text-lg"
        >
          <motion.div
            variants={fadeUp}
            className="flex flex-row items-center gap-2"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-4 lg:size-6 rotate-180"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
              />
            </svg>
            <a
              href="/careers"
              className="underline text-sm font-inter font-semibold hover:text-gray-300 text-left"
            >
              Volver al formulario
            </a>
          </motion.div>

          <motion.div
            variants={fadeUp}
            className="flex flex-row items-center gap-2"
          >
            <a
              href="/careers"
              className="underline text-sm font-inter font-semibold hover:text-gray-300 text-right"
            >
              Ver más puestos de trabajo
            </a>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-4 lg:size-6"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M17.25 8.25 21 12m0 0-3.75 3.75M21 12H3"
              />
            </svg>
          </motion.div>
        </motion.div>
      </motion.main>
      <Footer isSimple={true} />
    </div>
  );
};
